module.exports = __webpack_public_path__ + "static/media/facebook_round.895e6f1e.svg";